import React, {useState} from 'react';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { IconButton, Avatar, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import profileIcon from '../Assets/images/profile-icon.svg';
import LogoutIcon from '@mui/icons-material/Logout'; // Import the Logout icon
import { useHistory } from "react-router-dom";
import { react } from '@babel/types';
import '../Assets/styles/newStyles/Topbar.css'
import { styled } from '@mui/system';


const settings = [ 'Logout'];

// const useStyles = makeStyles((theme) => ({
//   profileIcon: {
//     // position: 'fixed',
//     // top: 8,
//     // right: 8,
//     // zIndex: theme.zIndex.drawer + 1, // Ensure the icon is above the drawer if present
//     [theme.breakpoints.down('sm')]: {
//       position: 'static',
//     },
//     [theme.breakpoints.up('sm')]: {
//       position: 'fixed',
//       top: 8,
//       right: 8,
//     },
//   },
// }));
const theme = createTheme({
  overrides: {
    MuiContainer: {
      root: {
        display: 'flex',
        flexDirection: 'row',
      },
    },
  },
});

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    position: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    position: 'fixed',
    top: 8,
    right: 8,
  },
}));

function Topbar() {
  // const theme = useTheme();
  // const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory(); 
  const [doctorName, setDoctorName] = useState(localStorage.name);
  const [role, setRole] = useState(localStorage.role);


  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleLogout(); // Call handleLogout function passed from props
    handleCloseMenu(); // Close the menu after logout
  };
  const handleLogout = () => {
    localStorage.clear(); // Clear local storage
   history.push("/"); // Redirect to the login page
  }

  return (
    <ThemeProvider theme={theme}>
      <div className='toolbar-main'>
        <div>
          <p className='doctor-name' style={{textTransform:'capitalize'}} >{doctorName}</p>
          <p className='topbar-role' style={{textTransform:'capitalize'}} >{role}</p>
        </div>
        {/* <IconButton style={{ position: 'absolute', top: 8, right: 8 }} onClick={handleOpenMenu} className={classes.profileIcon}>
          <Avatar alt="Profile" src={profileIcon} />
        </IconButton> */}
        <StyledIconButton onClick={handleOpenMenu}>
          <Avatar alt="Profile" src={profileIcon} />
        </StyledIconButton>
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          getContentAnchorEl={null}
        >
          {settings.map((setting, index) => (
            <MenuItem key={index} onClick={setting === 'Logout' ? handleLogoutClick : handleCloseMenu}>
              {setting === 'Logout' ? (
                <>
                  <ListItemIcon>
                    <LogoutIcon />
                  </ListItemIcon>
                  <ListItemText primary={setting} />
                </>
              ) : (
                <ListItemText primary={setting} />
              )}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </ThemeProvider>
  );
}

export default Topbar;
